"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrongSociety = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const Resources_1 = require("../../Resources");
class StrongSociety {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.STRONG_SOCIETY;
        this.description = 'Gain 2 M€ for each City tile (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.REDS;
        this.currentDelegate = PartyName_1.PartyName.MARS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const amount = Math.min(5, player.getCitiesCount()) + turmoil.getPlayerInfluence(player);
            if (amount > 0) {
                player.addResource(Resources_1.Resources.MEGACREDITS, amount * 2, { log: true, from: this.name });
            }
        });
    }
}
exports.StrongSociety = StrongSociety;
//# sourceMappingURL=StrongSociety.js.map